import { Restaurant } from '@carbon/icons-react';
import { Navigate, Route } from 'react-router';
import type { NavGroup } from '../AdminShell';
import { OrderGuard as Guard } from '../orders/OrderGuard';
import { KitchenTicketDetailPage } from './KitchenTicketDetailPage';
import { KitchenTicketsPage } from './KitchenTicketsPage';
import { KITCHEN_READ_PERMISSION, type KitchenMode } from './model';
import { PrintJobsPage } from './PrintJobsPage';
import { RoutingPage } from './RoutingPage';
import { StationsBoard } from './StationsBoard';

/** The side nav group for kitchen monitoring, shown to users who can read kitchen tickets. */
export function kitchenNav(mode: KitchenMode): NavGroup {
  const permission = KITCHEN_READ_PERMISSION[mode];
  return {
    label: 'admin.nav.kitchen',
    icon: Restaurant,
    items: [
      { label: 'admin.nav.kitchenStations', path: '/kitchen/stations', permission },
      { label: 'admin.nav.kitchenTickets', path: '/kitchen/tickets', permission },
      ...(mode === 'store' ? [{ label: 'admin.nav.printQueue' as const, path: '/kitchen/print-queue', permission }] : []),
      { label: 'admin.nav.kitchenRouting', path: '/kitchen/routing', permission },
    ],
  };
}

/** Kitchen monitoring screens (stations, tickets, print queue at the store, routing). Use inside <Routes>. */
export function kitchenRoutes(mode: KitchenMode) {
  const read = KITCHEN_READ_PERMISSION[mode];
  return [
    <Route key="kitchen" path="/kitchen" element={<Navigate to="/kitchen/stations" replace />} />,
    <Route key="kitchen-stations" path="/kitchen/stations" element={<Guard permission={read}><StationsBoard mode={mode} /></Guard>} />,
    <Route key="kitchen-tickets" path="/kitchen/tickets" element={<Guard permission={read}><KitchenTicketsPage mode={mode} /></Guard>} />,
    <Route key="kitchen-ticket" path="/kitchen/tickets/:id" element={<Guard permission={read}><KitchenTicketDetailPage mode={mode} /></Guard>} />,
    ...(mode === 'store'
      ? [<Route key="kitchen-print" path="/kitchen/print-queue" element={<Guard permission={read}><PrintJobsPage mode={mode} /></Guard>} />]
      : []),
    <Route key="kitchen-routing" path="/kitchen/routing" element={<Guard permission={read}><RoutingPage mode={mode} /></Guard>} />,
  ];
}
